import React from "react";
import styles from "./PrivacyPolicy.module.css";

export default function PrivacyPolicy() {
  return (
    <div className={styles.privacyRoot}>
      <div className={styles.privacyContainer}>
        <h1 className={styles.privacyTitle}>Polityka Prywatności Paperly.pl</h1>
        <p>
          <small>
            Wejście w życie: 2025-06-01 • Ostatnia aktualizacja: 2025-09-08
          </small>
        </p>

        <h2>1. Postanowienia ogólne</h2>
        <p>
          Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych
          użytkowników korzystających z serwisu internetowego Paperly.pl (dalej: „Serwis”) oraz usług
          świadczonych przez Bartosza Skrzypka prowadzącego działalność gospodarczą pod firmą Codellio
          Bartosz Skrzypek, z siedzibą w Polsce, NIP: 8172154584 (dalej: „Administrator”).
        </p>
        <p>
          Dokument realizuje obowiązek informacyjny wynikający z art. 13 i 14 RODO oraz stanowi wyraz
          dbałości o bezpieczeństwo danych osobowych Użytkowników.
        </p>

        <h2>2. Administrator danych</h2>
        <p>Administratorem danych osobowych jest:</p>
        <p>
          Codellio Bartosz Skrzypek<br />
          NIP: 8172154584<br />
          e-mail: <a href="mailto:kontakt@paperly.pl">kontakt@paperly.pl</a>
        </p>

        <h2>3. Podstawa i cele przetwarzania</h2>
        <p>Dane osobowe Użytkowników przetwarzane są:</p>
        <ul>
          <li>w celu świadczenia usług drogą elektroniczną i realizacji umowy (art. 6 ust. 1 lit. b RODO),</li>
          <li>w celu obsługi zgłoszeń i kontaktu (art. 6 ust. 1 lit. f RODO),</li>
          <li>w celach księgowych i podatkowych (art. 6 ust. 1 lit. c RODO),</li>
          <li>w przypadku wyrażenia zgody – w celach marketingowych (art. 6 ust. 1 lit. a RODO).</li>
        </ul>

        <h2>4. Zakres przetwarzanych danych</h2>
        <p>Administrator może przetwarzać następujące dane osobowe:</p>
        <ul>
          <li>imię i nazwisko,</li>
          <li>adres e-mail,</li>
          <li>numer telefonu,</li>
          <li>dane firmy (NIP, REGON, adres), jeśli użytkownik działa jako przedsiębiorca,</li>
          <li>dane niezbędne do wystawienia faktury lub rozliczeń,</li>
          <li>dane techniczne (np. adres IP, logi serwera).</li>
        </ul>
        <p>Podanie danych jest dobrowolne, ale niezbędne do korzystania z usług Serwisu.</p>

        <h2>5. Odbiorcy danych</h2>
        <p>Dane mogą być przekazywane wyłącznie podmiotom przetwarzającym dane na zlecenie Administratora, w szczególności:</p>
        <ul>
          <li>dostawcom usług hostingowych i chmurowych (Amazon Web Services – lokalizacja UE),</li>
          <li>dostawcom domen i poczty elektronicznej (OVH – w zakresie rejestracji domeny),</li>
          <li>podmiotom świadczącym usługi księgowe, prawne, IT,</li>
          <li>organom państwowym – wyłącznie gdy obowiązek wynika z przepisów prawa.</li>
        </ul>
        <p>Dane nie są sprzedawane ani udostępniane osobom trzecim w celach komercyjnych.</p>

        <h2>6. Przekazywanie danych poza EOG</h2>
        <p>
          Dane osobowe nie są co do zasady przekazywane poza Europejski Obszar Gospodarczy. W przypadku
          korzystania z usług dostawców technologicznych, którzy mogą mieć serwery poza EOG (np. Amazon Web
          Services), przekazanie danych odbywa się zgodnie z RODO – na podstawie standardowych klauzul umownych
          zatwierdzonych przez Komisję Europejską oraz przy zachowaniu odpowiednich zabezpieczeń.
        </p>

        <h2>7. Okres przechowywania danych</h2>
        <p>Dane osobowe przechowywane są:</p>
        <ul>
          <li>przez okres świadczenia usług i trwania umowy,</li>
          <li>do momentu przedawnienia roszczeń wynikających z umowy,</li>
          <li>w przypadku danych wymaganych prawem (np. księgowych) – przez okres wskazany w przepisach,</li>
          <li>do momentu cofnięcia zgody – w przypadku przetwarzania na jej podstawie.</li>
        </ul>

        <h2>8. Prawa użytkowników</h2>
        <p>Użytkownikom przysługują prawa wynikające z RODO, w szczególności:</p>
        <ul>
          <li>prawo dostępu do danych,</li>
          <li>prawo sprostowania danych,</li>
          <li>prawo do usunięcia danych („prawo do bycia zapomnianym”),</li>
          <li>prawo ograniczenia przetwarzania,</li>
          <li>prawo do przenoszenia danych,</li>
          <li>prawo sprzeciwu wobec przetwarzania,</li>
          <li>prawo cofnięcia zgody w dowolnym momencie.</li>
        </ul>
        <p>
          W celu realizacji powyższych praw Użytkownik może skontaktować się z Administratorem na adres e-mail:
          <a href="mailto:kontakt@paperly.pl"> kontakt@paperly.pl</a>.
        </p>

        <h2>9. Prawo do wniesienia skargi</h2>
        <p>
          Użytkownik ma prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (UODO), jeśli uzna,
          że przetwarzanie jego danych osobowych narusza przepisy RODO.
        </p>

        <h2>10. Zabezpieczenia danych</h2>
        <p>
          Administrator stosuje środki techniczne i organizacyjne zapewniające ochronę danych osobowych
          odpowiednią do zagrożeń i kategorii danych. W szczególności:
        </p>
        <ul>
          <li>szyfrowanie transmisji danych (SSL),</li>
          <li>stosowanie zabezpieczeń serwerów i kopii zapasowych,</li>
          <li>dostęp do danych wyłącznie dla osób upoważnionych.</li>
        </ul>

        <h2>11. Pliki cookies</h2>
        <p>
          Serwis korzysta z plików cookies, które są zapisywane na urządzeniu końcowym Użytkownika. Cookies
          wykorzystywane są w celu zapewnienia prawidłowego działania Serwisu, analizy ruchu oraz w celach
          statystycznych.
        </p>
        <p>
          Użytkownik może w każdej chwili zmienić ustawienia dotyczące plików cookies w swojej przeglądarce.
          Ograniczenie stosowania plików cookies może wpłynąć na niektóre funkcjonalności Serwisu.
        </p>
        <p>
          Serwis może korzystać z narzędzi analitycznych (np. Google Analytics), które wykorzystują pliki cookies
          podmiotów trzecich.
        </p>

        <h2>12. Zmiany Polityki Prywatności</h2>
        <p>
          Administrator zastrzega sobie prawo do wprowadzania zmian w niniejszej Polityce Prywatności. O wszelkich
          zmianach Użytkownicy zostaną poinformowani poprzez publikację nowej treści dokumentu na stronie internetowej
          Serwisu.
        </p>
      </div>
    </div>
  );
} 